import { render, staticRenderFns } from "./priceReport.vue?vue&type=template&id=bdfeeea6&scoped=true"
import script from "./priceReport.vue?vue&type=script&lang=js"
export * from "./priceReport.vue?vue&type=script&lang=js"
import style0 from "./priceReport.vue?vue&type=style&index=0&id=bdfeeea6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdfeeea6",
  null
  
)

export default component.exports